var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 171,
    viewBox: "0 0 183 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65869 101.456V170.917H42.5768V169.263H3.31753V103.11H42.5768V101.456H1.65869Z",
    fill: "#67E2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40015 127.366H42.577V109.174H9.40015V127.366Z",
    fill: "#67E2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40015 137.84H31.518V136.187H9.40015V137.84Z",
    fill: "#67E2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40015 147.212H22.1179V145.558H9.40015V147.212Z",
    fill: "#108DA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40015 156.584H22.1179V154.93H9.40015V156.584Z",
    fill: "#108DA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0352 77.8158C14.5472 77.8158 13.3357 79.0231 13.3357 80.5072C13.3357 81.9907 14.5472 83.1985 16.0352 83.1985C17.5237 83.1985 18.7347 81.9907 18.7347 80.5072C18.7347 79.0231 17.5237 77.8158 16.0352 77.8158ZM16.0352 84.9825C13.5597 84.9825 11.5464 82.9747 11.5464 80.5072C11.5464 78.0391 13.5597 76.0319 16.0352 76.0319C18.5108 76.0319 20.524 78.0391 20.524 80.5072C20.524 82.9747 18.5108 84.9825 16.0352 84.9825Z",
    fill: "#67E2C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.507 37.6088L80.7409 42.5659L84.4164 38.3514L78.507 37.6088ZM80.2914 45.6035L75.7832 35.5994L87.707 37.0977L80.2914 45.6035Z",
    fill: "#67E2C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.964 41.1889L163.413 40.6035L165.824 34.261L171.908 36.1993L171.611 23.178L182.511 32.7802L181.412 34.0195L173.356 26.9217L173.619 38.481L166.817 36.3139L164.964 41.1889Z",
    fill: "#67E2C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5337 124.857L68.2346 130.107L71.1276 128.08C71.4008 127.889 71.5827 127.603 71.6402 127.276C71.6972 126.948 71.6231 126.618 71.4318 126.345L69.1669 123.133C68.7704 122.571 67.9897 122.435 67.4262 122.83L64.5337 124.857ZM67.8315 132.412L62.2224 124.455L66.4729 121.477C67.784 120.558 69.6021 120.874 70.5238 122.182L72.7887 125.395C73.2349 126.028 73.4074 126.797 73.2742 127.56C73.1404 128.323 72.7174 128.988 72.0815 129.434L67.8315 132.412Z",
    fill: "#67E2C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7162 155.979L30.8442 146.443L62.7963 124.054L63.7496 125.407L32.1204 147.571L28.7364 153.864L35.8213 152.821L67.0673 130.925L68.0211 132.279L36.4533 154.399L25.7162 155.979Z",
    fill: "#67E2C2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1563 156.682L25.2019 155.329L27.5724 153.668L28.5262 155.022L26.1563 156.682Z",
    fill: "#67E2C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8183 153.834L32.4752 149.09L33.8322 148.14L37.1753 152.883L35.8183 153.834Z",
    fill: "#67E2C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.201 92.6352H96.7656V92.3386C96.7656 87.0221 101.089 82.7122 106.422 82.7122H112.546C117.879 82.7122 122.201 87.0221 122.201 92.3386V92.6352Z",
    fill: "#67E2C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.149 125.463L91.1122 113.455L101.121 101.148L106.273 105.313L99.6989 113.397L106.245 121.228L101.149 125.463Z",
    fill: "#67E2C2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.346 125.463L128.383 113.455L118.374 101.148L113.222 105.313L119.796 113.397L113.25 121.228L118.346 125.463Z",
    fill: "#67E2C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.331 92.6353V101.511L113.275 105.315H105.692L100.636 101.511V92.6353H118.331Z",
    fill: "#67E2C2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.438 55.6993H55.5285C52.3457 55.6993 49.7651 58.2722 49.7651 61.4454V69.4814H169.202V61.4454C169.202 58.2722 166.622 55.6993 163.438 55.6993Z",
    fill: "#67E2C2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.202 170.366H48.1062V149.417H49.765V168.712H167.543L167.515 70.0325H49.765V130.122H48.1062V68.3787H169.174L169.202 170.366Z",
    fill: "#108DA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2648",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 183,
    height: 171
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 170.917H182.511V0H0V170.917Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2648)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.39 95.3916H178.049V89.8788H176.39V95.3916Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.049 82.7122H176.39V61.3247C176.39 54.271 170.634 48.5328 163.559 48.5328H130.495V46.8789H163.559C171.549 46.8789 178.049 53.3592 178.049 61.3247V82.7122Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.765 68.3789H167.543V62.4245C167.543 59.0203 164.765 56.2506 161.35 56.2506H55.9575C52.5431 56.2506 49.765 59.0203 49.765 62.4245V68.3789ZM169.202 70.0327H48.1062V62.4245C48.1062 58.1085 51.6285 54.5968 55.9575 54.5968H161.35C165.68 54.5968 169.202 58.1085 169.202 62.4245V70.0327Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7478 60.4875C58.6607 60.4875 57.7754 61.3702 57.7754 62.454C57.7754 63.5383 58.6607 64.4209 59.7478 64.4209C60.8354 64.4209 61.7201 63.5383 61.7201 62.454C61.7201 61.3702 60.8354 60.4875 59.7478 60.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7612 60.4875C65.6741 60.4875 64.7888 61.3702 64.7888 62.454C64.7888 63.5383 65.6741 64.4209 66.7612 64.4209C67.8488 64.4209 68.7335 63.5383 68.7335 62.454C68.7335 61.3702 67.8488 60.4875 66.7612 60.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7751 60.4875C72.6875 60.4875 71.8027 61.3702 71.8027 62.454C71.8027 63.5383 72.6875 64.4209 73.7751 64.4209C74.8622 64.4209 75.7475 63.5383 75.7475 62.454C75.7475 61.3702 74.8622 60.4875 73.7751 60.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.298 81.3119C154.997 81.3119 154.695 81.3323 154.392 81.3725C152.625 81.6102 151.057 82.5187 149.976 83.9327C148.895 85.3456 148.431 87.0943 148.669 88.8556C149.16 92.4908 152.526 95.0471 156.178 94.5625C157.945 94.3249 159.513 93.4159 160.594 92.0035C161.675 90.59 162.139 88.8413 161.9 87.0794C161.663 85.3175 160.751 83.7541 159.332 82.6763C158.157 81.7827 156.751 81.3119 155.298 81.3119ZM155.282 96.2765C151.174 96.2765 147.587 93.2416 147.025 89.0762C146.728 86.8777 147.307 84.6946 148.657 82.9299C150.007 81.1647 151.965 80.0302 154.171 79.7341C156.379 79.4359 158.568 80.0153 160.338 81.361C162.109 82.7061 163.248 84.6582 163.544 86.8578C163.842 89.058 163.263 91.2416 161.913 93.0063C160.563 94.7704 158.605 95.9054 156.399 96.2015C156.023 96.2522 155.65 96.2765 155.282 96.2765ZM154.818 109.453L152.364 104.703C151.398 104.534 150.447 104.282 149.523 103.95L145.032 106.867L139.718 102.827L141.351 97.7374C140.783 96.933 140.287 96.0835 139.873 95.2037L134.628 94.1033L133.737 87.5023L138.501 85.0529C138.668 84.0942 138.92 83.1449 139.253 82.221L136.325 77.7424L140.377 72.4451L145.483 74.0763C146.283 73.5135 147.134 73.0195 148.023 72.6017L148.393 70.848L150.016 71.1882L149.473 73.7665L149.083 73.938C148.034 74.3983 147.039 74.976 146.124 75.6547L145.782 75.9088L140.986 74.3768L138.354 77.8168L141.105 82.0242L140.95 82.42C140.534 83.4873 140.239 84.5964 140.074 85.7167L140.011 86.1373L135.537 88.4378L136.116 92.7251L141.043 93.7593L141.214 94.1491C141.669 95.1833 142.247 96.1756 142.935 97.0984L143.189 97.4391L141.654 102.22L145.107 104.844L149.325 102.105L149.721 102.258C150.789 102.672 151.902 102.967 153.032 103.136L153.452 103.198L155.757 107.658L160.06 107.079L161.097 102.172L161.486 102C162.539 101.536 163.534 100.958 164.446 100.282L164.787 100.027L167.799 100.988L167.293 102.564L165.088 101.86C164.29 102.42 163.438 102.916 162.547 103.335L161.441 108.562L154.818 109.453Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3302 107.335L76.5288 109.903L78.9496 108.981L78.8738 105.604L79.2139 105.349C79.8204 104.894 80.3773 104.369 80.8677 103.788L81.142 103.464L84.5211 103.729L85.5783 101.368L83.1254 99.0345L83.1868 98.6134C83.2946 97.8614 83.3167 97.0984 83.2526 96.3454L83.2161 95.922L85.7923 93.729L84.8661 91.3133L81.481 91.3921L81.2249 91.0536C80.7654 90.4461 80.2385 89.891 79.6579 89.4042L79.3316 89.1302L79.5993 85.7619L77.2332 84.7067L74.8931 87.1506L74.4712 87.091C73.7131 86.9841 72.9473 86.9637 72.1947 87.0271L71.7701 87.064L69.5699 84.495L67.1474 85.4173L67.2271 88.7939L66.8859 89.0492C66.2821 89.5012 65.7258 90.0266 65.232 90.6104L64.9572 90.9346L61.5793 90.6694L60.5209 93.0305L62.9705 95.363L62.9113 95.7831C62.8051 96.5339 62.783 97.2991 62.8455 98.0566L62.8803 98.4788L60.3064 100.669L61.2326 103.085L64.616 103.007L64.8726 103.345C65.3332 103.954 65.8613 104.509 66.4402 104.996L66.7659 105.27L66.4999 108.635L68.8671 109.691L71.2083 107.248L71.6302 107.307C72.3839 107.415 73.1491 107.436 73.905 107.372L74.3302 107.335ZM76.0267 111.865L73.6158 109.048C73.0197 109.077 72.4198 109.06 71.8254 108.998L69.258 111.678L64.7543 109.669L65.0462 105.977C64.605 105.578 64.1925 105.143 63.8143 104.68L60.1007 104.766L58.339 100.17L61.1646 97.7644C61.1375 97.169 61.1546 96.572 61.216 95.9793L58.5292 93.4203L60.5425 88.929L64.2483 89.2201C64.6514 88.7768 65.0866 88.3661 65.5489 87.9924L65.4615 84.2888L70.0709 82.5347L72.4839 85.3506C73.0789 85.3242 73.6778 85.3396 74.2744 85.4013L76.8417 82.7205L81.346 84.7282L81.0519 88.4224C81.4937 88.822 81.9056 89.2564 82.2833 89.719L85.998 89.6324L87.7597 94.229L84.9341 96.6348C84.9629 97.2291 84.9446 97.8261 84.8821 98.4193L87.57 100.977L85.5578 105.47L81.852 105.178C81.45 105.62 81.0143 106.031 80.5509 106.405L80.6344 110.11L76.0267 111.865Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4077 90.9814H121.11C120.69 86.3518 116.775 82.7122 112.024 82.7122H106.494C101.743 82.7122 97.8285 86.3518 97.4077 90.9814ZM122.806 92.6353H95.7118V91.8083C95.7118 85.881 100.549 81.0583 106.494 81.0583H112.024C117.97 81.0583 122.806 85.881 122.806 91.8083V92.6353Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9964 114.436L101.168 125.408L105.042 122.189L98.5234 114.391L105.071 106.34L101.155 103.174L91.9964 114.436ZM100.955 127.738L89.8488 114.45L100.912 100.848L107.404 106.097L100.671 114.377L107.377 122.401L100.955 127.738Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.454 122.189L118.327 125.409L127.499 114.437L118.34 103.174L114.424 106.34L120.972 114.391L114.454 122.189ZM118.54 127.737L112.118 122.401L118.825 114.377L112.091 106.097L118.584 100.847L129.647 114.45L118.54 127.737Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.083 101.456H101.742V92.084H100.083V101.456Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.225 102.558H118.884V92.084H117.225V102.558Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.166 106.969H113.354V105.315H106.166V106.969Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.931 103.661H110.59V92.084H108.931V103.661Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.189 83.2635H102.848V69.4814H101.189V83.2635Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.119 83.2635H117.778V69.4814H116.119V83.2635Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.6 148.098C109.468 149.308 106.754 148.565 105.54 146.439C104.327 144.313 105.071 141.608 107.204 140.398C109.336 139.188 112.049 139.93 113.264 142.057C114.477 144.182 113.732 146.888 111.6 148.098ZM109.841 131.287L98.4246 137.765L98.3439 150.862L109.679 157.479L121.095 151.001L121.176 137.905L109.841 131.287Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.395 140.646C108.79 140.646 108.177 140.797 107.614 141.117C105.882 142.1 105.275 144.304 106.261 146.03C107.247 147.756 109.457 148.36 111.189 147.379C112.921 146.396 113.528 144.192 112.542 142.466C111.877 141.3 110.653 140.646 109.395 140.646ZM109.41 149.503C107.575 149.503 105.79 148.549 104.82 146.848C103.382 144.33 104.267 141.114 106.793 139.679C109.32 138.246 112.546 139.129 113.984 141.647C115.421 144.166 114.536 147.383 112.01 148.816C111.189 149.282 110.293 149.503 109.41 149.503ZM98.9005 150.39L109.409 156.524L119.993 150.518L120.067 138.377L109.559 132.243L98.9746 138.248L98.9005 150.39ZM109.397 158.434L97.2356 151.334L97.3219 137.283L109.57 130.333L121.732 137.433L121.645 151.483L109.397 158.434Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.602 136.187H157.59V134.533H131.602V136.187Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.602 145.558H157.59V143.904H131.602V145.558Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.602 156.584H157.59V154.93H131.602V156.584Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2712 156.584H86.2598V154.93H60.2712V156.584Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.542 145.558H86.2598V143.904H73.542V145.558Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2653 93.1866C71.2836 93.1866 69.6712 94.7941 69.6712 96.7699C69.6712 98.7457 71.2836 100.353 73.2653 100.353C75.2471 100.353 76.8595 98.7457 76.8595 96.7699C76.8595 94.7941 75.2471 93.1866 73.2653 93.1866ZM73.2653 102.007C70.369 102.007 68.0123 99.6575 68.0123 96.7699C68.0123 93.8823 70.369 91.5327 73.2653 91.5327C76.1617 91.5327 78.5183 93.8823 78.5183 96.7699C78.5183 99.6575 76.1617 102.007 73.2653 102.007Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3358 29.246L90.0082 17.0753L96.9162 4.66321L111.151 4.4223L118.479 16.593L114.629 23.5093L113.179 22.7072L116.563 16.6249L110.222 6.09214L97.9021 6.30107L91.9236 17.0428L98.2653 27.5761L106.151 27.4405L106.18 29.0944L97.3358 29.246Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.224 13.2496C103.58 13.2496 102.947 13.4232 102.381 13.7623C101.558 14.2546 100.977 15.0368 100.744 15.9658C100.511 16.8941 100.656 17.8572 101.15 18.6775C101.644 19.4984 102.429 20.0783 103.36 20.3099C104.291 20.5425 105.257 20.3981 106.08 19.9058C106.903 19.4135 107.484 18.6312 107.717 17.7023C107.949 16.7739 107.806 15.8108 107.312 14.9905C106.817 14.1697 106.033 13.5897 105.101 13.3582C104.811 13.2854 104.516 13.2496 104.224 13.2496ZM104.24 22.0729C103.813 22.0729 103.383 22.0205 102.958 21.9146C101.596 21.5756 100.45 20.7277 99.7274 19.5287C99.0052 18.3297 98.7951 16.9217 99.1346 15.565C99.4747 14.2077 100.325 13.0638 101.527 12.3438C102.73 11.6244 104.142 11.4138 105.503 11.7534C106.864 12.0925 108.012 12.9398 108.734 14.1394C109.456 15.3384 109.667 16.7464 109.327 18.1031C108.986 19.4603 108.137 20.6042 106.933 21.3237C106.106 21.8187 105.18 22.0729 104.24 22.0729Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97656 63.4173H42.024V61.7634H4.97656V63.4173Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42444 63.7436C4.38574 63.7436 4.34648 63.743 4.30722 63.7425C1.93231 63.6807 -0.000244141 61.6283 -0.000244141 59.1674V23.7249H1.6586V59.1674C1.6586 60.7402 2.86624 62.0506 4.35035 62.0892C5.09848 62.1068 5.81455 61.8306 6.35312 61.3069C6.89169 60.7837 7.18807 60.0825 7.18807 59.3333V13.8018H41.2966L49.3365 5.53259H68.5653V51.289H66.9064V7.18644H50.0387L41.9989 15.4557H8.84692V59.3333C8.84692 60.5329 8.37304 61.6542 7.511 62.4916C6.67715 63.3014 5.58563 63.7436 4.42444 63.7436Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5649 31.4429H23.7767V29.7891H21.5649V31.4429ZM25.9885 31.4429H28.2003V29.7891H25.9885V31.4429ZM30.4121 31.4429H32.6239V29.7891H30.4121V31.4429ZM34.8357 31.4429H37.0475V29.7891H34.8357V31.4429ZM39.2593 31.4429H41.4711V29.7891H39.2593V31.4429ZM43.6828 31.4429H45.8946V29.7891H43.6828V31.4429ZM48.1064 31.4429H50.3182V29.7891H48.1064V31.4429ZM52.53 31.4429H54.7418V29.7891H52.53V31.4429Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5415 43.0198H50.3182V41.366H26.5415V43.0198Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.271 48.3405L115.183 47.0913L132.214 32.3484L133.301 33.5976L116.271 48.3405Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.255 49.6617C98.4906 46.2558 99.5484 42.0413 102.716 39.8577L126.968 24.7944L127.845 26.198L103.626 41.2397C101.176 42.93 100.346 46.2338 101.729 48.9025L100.255 49.6617Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.452 1.65384C142.995 1.65384 141.531 1.84183 140.086 2.21891C135.653 3.37605 131.936 6.18538 129.622 10.1282C127.307 14.0709 126.672 18.6752 127.834 23.0927C128.993 27.5128 131.809 31.2169 135.763 33.5229C139.717 35.8273 144.334 36.4601 148.768 35.303C156.755 33.2158 162.041 25.8336 161.553 17.7728L152.406 25.0144L141.207 21.2139L140.53 9.54379L149.511 2.42619C147.862 1.91239 146.162 1.65384 144.452 1.65384ZM144.39 37.5225C141.094 37.5225 137.845 36.652 134.926 34.9496C130.589 32.4214 127.5 28.3585 126.229 23.5111C124.955 18.667 125.652 13.6172 128.19 9.29241C130.729 4.9687 134.804 1.88814 139.666 0.619087C143.628 -0.414567 147.721 -0.150503 151.505 1.38427L152.819 1.91791L142.236 10.3046L142.799 20.0071L152.084 23.1583L162.834 14.647L163.043 16.0677C164.433 25.5183 158.476 34.4755 149.187 36.9028C147.599 37.3174 145.989 37.5225 144.39 37.5225Z",
    fill: "#67E2C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.fb0ecebd378c00ffe815dd1d62892fae.svg";
export { ForwardRef as ReactComponent };